import { EnumSchema } from '../metadata-schema';

export const CohortrendementVanafWaarde: EnumSchema = {
	"type": "string",
	"title": "CohortrendementVanafWaarde",
	"enum": [
		"Zonder vertraging",
		"Opgestroomd",
		"Afgestroomd",
		"Afgestroomd & gedoubleerd",
		"Gedoubleerd",
		"Opgestroomd & gedoubleerd"
	]
};
